import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { FlightListScope } from '../overview/domain/constants/FlightListScope';

export function getFlightsListUrl(scope?: FlightListScope, query?: string) {
	const searchParams = new URLSearchParams();
	if (scope) {
		searchParams.set('scope', scope);
	}

	if (query) {
		searchParams.set('query', query);
	}

	const url = `${PageRoutes.Flights}/?${searchParams.toString()}`;
	return url;
}
